<form [formGroup]="formGroup">
    <sc-sub-title>{{'Internal Contact' | translate:
        ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.title',
        translationService.language]}}</sc-sub-title>

    <sc-content-spacer [vertical]="true"></sc-content-spacer>

    <sc-string-field formControlName="reason"
        [label]="'reason' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.reason', translationService.language]">
    </sc-string-field>

    <sc-content-spacer [vertical]="true"></sc-content-spacer>

    <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>{{'Notes' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.notes',
            translationService.language]}}</mat-label>
        <textarea formControlName="note" matInput name="notes" cdkTextareaAutosize cdkAutosizeMinRows="3"
            cdkAutosizeMaxRows="8"></textarea>
    </mat-form-field>

    <sc-content-spacer [vertical]="true"></sc-content-spacer>

    <sc-flex >
        <sc-string-field [grow]="true" formControlName="name"
            [label]="'name' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.name', translationService.language]">
        </sc-string-field>
        <sc-content-spacer></sc-content-spacer>
        <sc-string-field [grow]="true" formControlName="department"
            [label]="'department' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.department', translationService.language]">
        </sc-string-field>
    </sc-flex>

    <sc-content-spacer [vertical]="true"></sc-content-spacer>

    <sc-flex >
        <sc-string-field [grow]="true" formControlName="phone"
            [label]="'phone' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.phone', translationService.language]">
        </sc-string-field>
        <sc-content-spacer></sc-content-spacer>
        <sc-string-field [grow]="true" formControlName="mail"
            [label]="'mail' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.mail', translationService.language]">
        </sc-string-field>
    </sc-flex>

    <!--mat-form-field class="col first ">
    <input matInput name="internalContact.name" [(ngModel)]="personalVisit.visitedPerson.name"
        placeholder="{{'name' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.name', translationService.language]}}"
        [readonly]="readonly">
</mat-form-field>
<mat-form-field class="col last">
    <input matInput name="internalContact.department" [(ngModel)]="personalVisit.visitedPerson.department"
        placeholder="{{'department' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.department', translationService.language]}}"
        [readonly]="readonly">
</mat-form-field>
</div>
<div class="row">
    <mat-form-field class="col first">
        <input matInput name="internalContact.phone" [(ngModel)]="personalVisit.visitedPerson.phone"
            placeholder="{{'phone' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.phone', translationService.language]}}"
            [readonly]="readonly">
    </mat-form-field>
    <mat-form-field class="col colspan-2 last">
        <input matInput name="internalContact.mail" [(ngModel)]="personalVisit.visitedPerson.mail"
            placeholder="{{'mail' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.mail', translationService.language]}}"
            [readonly]="readonly">
    </mat-form-field>
</div-->

    <!--mat-form-field class="col fill first last">
    <input matInput name="reason" [(ngModel)]="personalVisit.reason"
        placeholder="{{}}"
        [readonly]="readonly">
</mat-form-field>
<mat-form-field class="col fill first last">
    <textarea matInput name="notes" [(ngModel)]="personalVisit.notes"
        placeholder="{{'Notes' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.notes', translationService.language]}}"
        [readonly]="readonly" cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="8"></textarea>
</mat-form-field>

<div class="row">
    <h5>{{'Internal Contact' | translate:
      ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.title',
      translationService.language]}}</h5>
  </div>
  <div class="row">
    <mat-form-field class="col first ">
      <input matInput name="internalContact.name" [(ngModel)]="personalVisit.visitedPerson.name"
        placeholder="{{'name' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.name', translationService.language]}}"
        [readonly]="readonly">
    </mat-form-field>
    <mat-form-field class="col last">
      <input matInput name="internalContact.department" [(ngModel)]="personalVisit.visitedPerson.department"
        placeholder="{{'department' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.department', translationService.language]}}"
        [readonly]="readonly">
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field class="col first">
      <input matInput name="internalContact.phone" [(ngModel)]="personalVisit.visitedPerson.phone"
        placeholder="{{'phone' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.phone', translationService.language]}}"
        [readonly]="readonly">
    </mat-form-field>
    <mat-form-field class="col colspan-2 last">
      <input matInput name="internalContact.mail" [(ngModel)]="personalVisit.visitedPerson.mail"
        placeholder="{{'mail' | translate: ['tmc.personalvisit.dialog.details.additionalinformations.tab.details.internalcontact.mail', translationService.language]}}"
        [readonly]="readonly">
    </mat-form-field>
  </div>
</div-->
</form>
